module.exports = __webpack_public_path__ + "img/login-image-03.74ac1b2e.png";